/**
 * Съобщения за грешки.
 *
 */

const BY_CODE: Record<string, string> = {
  // - заявка от клиента -
  QUOTE_REQUIRED: "Липсва обект с данни за котиране.",
  QUOTE_NOT_FOUND: "Офертата е изтекла. Направете ново запитване.",
  QUOTE_SUPERSEDED: "Офертата е заменена от по-нова. Изберете отново.",
  QUOTE_INPUT_CHANGED:
    "Данните са променени след котирането. Направете ново запитване.",
  QUOTE_HANDLE_MALFORMED: "Невалиден идентификатор на оферта.",
  QUOTE_MISSING_PROVIDER: "Изберете застраховател.",
  CHANGED_SINCE_QUOTE:
    "Данните са променени след котирането. Направете ново запитване.",
  MESSAGE_ID_REQUIRED: "Липсва идентификатор на заявката.",
  MISSING_REQUIRED_FIELDS: "Липсват задължителни данни.",
  PURPOSE_UNKNOWN: "Непознато предназначение на МПС.",
  NO_PREMIUM: "Застрахователят не върна оферта за тези данни.",
  PURPOSE_NOT_SUPPORTED: "Застрахователят не поддържа това предназначение.",
  DZI_LESSEE_REQUIRED:
    "Въведете действителния лизингополучател в „Застраховащ“ и преизчислете офертите.",
  OZK_LESSEE_REQUIRED:
    "Въведете действителния лизингополучател в „Застраховащ“ и преизчислете офертите.",
  "USER_MESSAGE_RULE.LC_WITHOUT_LESSEE":
    "Въведете действителния лизингополучател в „Застраховащ“ и преизчислете офертите.",
  OZK_DRIVER_REQUIRED:
    "Въведете ЕГН на физическо лице в „Обичаен водач“ и преизчислете офертите.",
  INVALID_PROVIDER: "Непознат застраховател.",
  UNSUPPORTED_VALUE: "Неподдържана стойност.",
  REQUIRED: "Полето е задължително.",

  // - премия и издаване -
  PREMIUM_CHANGED:
    "Премията се промени спрямо офертата. Прегледайте новата цена.",
  PROVIDER_REJECTED: "Застрахователят отказа заявката.",
  PROVIDER_ERROR: "Грешка при застрахователя.",
  PROVIDER_TIMEOUT: "Застрахователят не отговори навреме.",
  PROVIDER_UNREACHABLE: "Няма връзка със застрахователя.",
  PROVIDER_NOT_AVAILABLE: "Застрахователят не е достъпен в момента.",
  PROVIDER_NOT_CONFIGURED: "Застрахователят не е конфигуриран.",
  PROVIDER_OUTCOME_UNKNOWN:
    "Застрахователят не върна потвърждение за заявката.",
  LOCAL_POLICY_WRITE_FAILED:
    "Полицата е издадена, но записът в базата данни не е завършен.",
  ADAPTER_ERROR: "Вътрешна грешка при обработката за този застраховател.",

  // - бланки -
  BLANK_SERIES_UNKNOWN: "Непозната серия бланки.",
  BLANK_UNPARSEABLE: "Номерът на бланката не може да бъде разчетен.",

  // - документи -
  DOCUMENT_NOT_AVAILABLE: "Документът не е наличен.",
  DOCUMENT_TYPE_UNKNOWN: "Непознат тип документ.",
  DOCUMENT_FETCH_FAILED: "Документът не можа да бъде изтеглен.",
  DOCUMENT_EMPTY: "Документът е празен.",
  DOCUMENT_NOT_A_PDF: "Полученият файл не е PDF.",
  DOCUMENT_UNREADABLE: "Документът не може да бъде прочетен.",

  // - вноски и плащане -
  AMOUNT_REQUIRED: "Въведете сума.",
  AMOUNT_INVALID: "Невалидна сума.",
  CURRENCY_INVALID: "Невалидна валута.",
  PAYMENT_TARGET_REQUIRED: "Изберете вноска за плащане.",
  PAYMENT_TARGET_WRONG_PROVIDER: "Вноската е към друг застраховател.",
  POLICY_NUMBER_REQUIRED: "Липсва номер на полица.",
  SCHEDULE_NOT_YET_AVAILABLE: "Погасителният план още не е наличен.",

  // - идемпотентност -
  IDEMPOTENCY_IN_FLIGHT: "Заявката вече се обработва. Изчакайте.",
  IDEMPOTENCY_KEY_REUSED: "Същият идентификатор е използван с други данни.",

  // - вътрешни -
  INTERNAL_ERROR: "Вътрешна грешка.",
  STORE_FULL: "Системата е претоварена. Опитайте отново.",
};

/**
 * Съобщения от застрахователите, които идват БЕЗ код - агрегаторът връща
 * `error.message` както го е получил. Подредени от по-конкретно към по-общо;
 * първото съвпадение печели.
 */
const BY_PATTERN: Array<[RegExp, string]> = [
  [
    /incorrect password|invalid credentials|unauthor/i,
    "Грешни данни за достъп до застрахователя.",
  ],
  [
    /token expired|expired token|validate jwt/i,
    "Изтекъл достъп до застрахователя.",
  ],
  [
    /timeout|timed out|ETIMEDOUT|ESOCKETTIMEDOUT/i,
    "Застрахователят не отговори навреме.",
  ],
  [
    /ECONNREFUSED|ENOTFOUND|EHOSTUNREACH|ENETUNREACH|ECONNRESET|EPIPE/i,
    "Няма връзка със застрахователя.",
  ],
  [
    /certificate|CERT_HAS_EXPIRED|SELF_SIGNED|ALTNAME/i,
    "Проблем със сертификата на застрахователя.",
  ],
  [
    /requires .*holderId|holderPerson|register the holder/i,
    "Застрахователят изисква застраховащият да е регистриран при него.",
  ],
  [
    /SOAP operation .* failed|SOAP fault/i,
    "Услугата на застрахователя върна грешка.",
  ],
  [
    /API .*(failed|неуспешна)|request failed/i,
    "Услугата на застрахователя върна грешка.",
  ],
  [/not supported|unsupported/i, "Застрахователят не поддържа тази заявка."],
  [/no (offer|premium|quote)|not found/i, "Застрахователят не върна оферта."],
];

/**
 * Технически съобщения, които понякога идват с българска обвивка (например
 * "Системна грешка: ..."). Те се проверяват преди правилото "има кирилица",
 * иначе вътрешният Oracle текст стига дословно до оператора.
 */
const TECHNICAL_BY_PATTERN: Array<[RegExp, string]> = [
  [
    /ORA-12526|TNS:listener:\s*all appropriate instances are in restricted mode/i,
    "Системата на застрахователя е временно недостъпна поради техническа поддръжка. Опитайте отново след няколко минути.",
  ],
];

const GENERIC = "Застрахователят не върна оферта.";

export interface TranslatedError {
  /** Текстът, който се показва на оператора - винаги на български. */
  text: string;
  /** Оригиналът, ако е различен - за tooltip и диагностика. */
  detail?: string;
}

/**
 * Превежда грешка към български. Приема кода и/или суровото съобщение - в
 * таблицата с оферти често има само второто.
 */
/**
 * Кодове, които НЕ носят информация - бекендът ги слага, когато застрахователят не
 * е върнал собствен код. Ако такъв код се преведе пръв, той изтрива по-конкретното
 * съобщение отдолу: "NO_PREMIUM" щеше да замени готовия български текст на
 * Дженерали с общо изречение.
 */
const SYNTHETIC_CODES = new Set([
  "NO_PREMIUM",
  "PROVIDER_ERROR",
  "ADAPTER_ERROR",
]);

export function translateError(
  code?: string | null,
  message?: string | null
): TranslatedError {
  const raw = (message || "").trim();

  // 1. Истински код - най-точният източник.
  if (code && !SYNTHETIC_CODES.has(code) && BY_CODE[code]) {
    return { text: BY_CODE[code], detail: raw || undefined };
  }

  // 2. Познат вътрешен технически текст може да е обвит в българско съобщение.
  for (const [pattern, text] of TECHNICAL_BY_PATTERN) {
    if (pattern.test(raw) || (code && pattern.test(code))) {
      return { text, detail: raw || undefined };
    }
  }

  // 3. Съобщение, което вече съдържа кирилица, е локализирано от бекенда или от
  //    застрахователя. Показва се както е - латински имена на марки в него са
  //    нормални ("Операцията с Generali API неуспешна.").
  if (/[Ѐ-ӿ]/.test(raw)) {
    return { text: raw };
  }

  // 4. Познат английски шаблон.
  for (const [pattern, text] of BY_PATTERN) {
    if (pattern.test(raw) || (code && pattern.test(code))) {
      return { text, detail: raw || undefined };
    }
  }

  // 5. Синтетичният код е последната смислена информация преди общото съобщение.
  if (code && BY_CODE[code]) {
    return { text: BY_CODE[code], detail: raw || undefined };
  }

  return { text: GENERIC, detail: raw || undefined };
}
